export const ONBOARDING_STEPS = {
    SCHEDULE: 'SCHEDULE',
    REVIEW: 'REVIEW'
  };

// Most children one classroom can hold at one lesson slot. Mirrors CLASSROOM_CAPACITY in
// api/src/common/classroom-capacity.ts; keep the two in step.
export const CLASS_CAPACITY = 12;

export const PLAN_PRICING = {
  SINGLE: { monthly: 80, currency: '£', label: 'Single Child Plan' },
  FAMILY: { monthly: 120, currency: '£', label: 'Family Plan' },
};